import React from 'react';
import {
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Drawer,
  Grow,
  Paper,
  Popper
} from '@mui/material';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { paperClasses } from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import { useWindowSize } from '../../../utils/hooks';
import { MOBILE_BREAKPOINT } from '../../../utils/constants';
import colors from '../../../scss/colors';
import MainButton from '../buttons/MainButton';

function DeleteDialog(props) {
  const { open, closeHandler, confirmHandler, config, pending = false } = props;
  const { t } = useTranslation();

  const size = useWindowSize();

  const deleteDialogContent = (
    <>
      <DialogContent
        sx={{
          ml: 4,
          mr: 4,
          p: 1.5
        }}
      >
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            pt: 2,
            minHeight: 70,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            color: size.width > MOBILE_BREAKPOINT ? colors.NAVY_BLUE : colors.BLACK,
            fontSize: size.width > MOBILE_BREAKPOINT ? '16px' : '12px'
          }}
        >
          <p>{config?.text}</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          ml: 4,
          mr: 4,
          mb: 4,
          p: 0,
          justifyContent: 'space-around'
        }}
      >
        <MainButton
          size='xmedium'
          action={closeHandler}
          variant='secondary'
          outlined
          forceWidth={'170px'}
          disabled={pending}
        >
          {t('common.general.cancel')}
        </MainButton>
        <MainButton
          size='xmedium'
          action={confirmHandler}
          variant='primary'
          forceWidth={'170px'}
          disabled={pending}
          pending={pending}
        >
          {t('common.general.delete')}
        </MainButton>
      </DialogActions>
    </>
  );

  return size.width > MOBILE_BREAKPOINT ? (
    <Dialog
      open={open}
      onClose={closeHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        zIndex: 1700,
        '& .MuiDialog-paper': {
          borderRadius: '10px'
        }
      }}
    >
      {deleteDialogContent}
    </Dialog>
  ) : (
    <Popper open={open} role={undefined} placement="bottom-start" transition disablePortal>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom'
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={closeHandler}>
              <Drawer
                anchor="bottom"
                open={open}
                onClose={closeHandler}
                sx={{
                  [`& .${paperClasses.root}`]: {
                    borderRadius: '10px 10px 0 0'
                  }
                }}
              >
                {deleteDialogContent}
              </Drawer>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}

export default DeleteDialog;
